import { BaseHttpService } from 'app/services';
import {
  DEFAULT_PAYMENT_PAGE_SIZE,
  TMultiSplitPaymentsResponse,
  TPayoutReceiptResponse,
  TUpdatePaymentAccountPayload,
} from 'modules/products/interfaces/multiSplitPayments';

export class MultiSplitPaymentsHttpService extends BaseHttpService {
  BASE_URL = `${process.env.REACT_APP_DASHBOARD_API_HOST}/proxy`;

  getApplicationPayments = async (
    applicationId: string,
    page = 0,
    size = DEFAULT_PAYMENT_PAGE_SIZE,
  ) => {
    const res = await this.get(
      `${this.BASE_URL}/originator/multisplit/application/${applicationId}?page=${page}&size=${size}`,
    );

    return res.data as TMultiSplitPaymentsResponse;
  };

  getApplicationReceipts = async (applicationId: string) => {
    const res = await this.get(
      `${this.BASE_URL}/originator/multisplit/application/${applicationId}/receipts`,
    );

    return res.data as TPayoutReceiptResponse;
  };

  getReceiptPdf = async (payoutId: string) => {
    const res = await this.get(
      `${this.BASE_URL}/originator/multisplit/payouts/${payoutId}/receipt?format=pdf`,
    );
    return res.data;
  };

  reprocessApplicationPayment = async (
    applicationId: string,
    paymentId: string,
  ) => {
    const res = await this.post(
      `${this.BASE_URL}/originator/multisplit/application/${applicationId}/reprocess`,
      { payment_id: paymentId },
    );
    return res.data;
  };

  updatePaymentAccount = async (
    accountId: string,
    payload: TUpdatePaymentAccountPayload,
  ) => {
    const res = await this.put(
      `${this.BASE_URL}/originator/multisplit/payment-account/${accountId}`,
      payload,
    );
    return res.data;
  };
}
